<template>
  <div
    id="login"
    style="background: url('makeup.jpg') no-repeat center; background-size: cover;"
    class="text-center"
  >
    <br />
    <div class="title m-2">{{ $t('login.t1') }}</div>
    <div class="subtitle m-2">{{ $t('login.t2') }}</div>
    <div class="subtitle m-2">{{ $t('login.t3') }}</div>
    <div class="subtitle m-2">{{ $t('login.t4') }}</div>

    <!-- Login Form -->
    <form v-if="showLoginForm" @submit.prevent>
      <input v-model="email" type="text" placeholder="メールアドレス" id="email1" />
      <br />
      <input
        v-model="password"
        type="password"
        placeholder="パスワード"
        id="password1"
        @keypress.enter="handleLogin"
      />
      <br />
      <button @click="handleLogin" class="btn btn-primary">ログイン</button>
      <br />
      <br />
      <table align="center">
        <tr>
          <td>新規会員登録はこちら（無料）</td>
          <td>
            <router-link class="nav-item nav-link" to="/signup">新規登録</router-link>
          </td>
        </tr>
      </table>

      <div class="text-right m-2">
        <b-button @click="toggleForm" variant="link" style="font-size: 13px">パスワードを忘れた場合</b-button>
      </div>
    </form>

    <!-- Forgot Password -->
    <form v-if="!showLoginForm" @submit.prevent class="password-reset">
      <div v-if="!passwordResetSuccess">
        <div>
          <br />
          <h2>パスワード再設定</h2>
          <p>ご登録いただいているメールアドレスを入力の上、送信ボタンを押してください。</p>
          <input
            v-model.trim="passwordForm.email"
            type="text"
            placeholder="メールアドレス"
            id="email2"
            class="m-1"
          />
          <button @click="handleResetPassword" class="btn btn-primary m-1">送信</button>
        </div>
        <div class="text-right m-2">
          <b-button @click="toggleForm" variant="link" style="font-size: 13px">ログインページに戻る</b-button>
        </div>
      </div>
      <!-- Forgot Password Email Sent -->
      <div v-else>
        <br />
        <h2>メール送信完了</h2>
        <p>メールを確認してください。</p>
        <div class="text-right m-2">
          <b-button @click="toggleForm" variant="link" style="font-size: 13px">ログインページに戻る</b-button>
        </div>
      </div>
    </form>
    <div style="height: 250px;"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      email: '',
      password: '',
      passwordForm: {
        email: '',
      },
      showLoginForm: true,
      passwordResetSuccess: false,
    };
  },
  methods: {
    ...mapActions(['login', 'resetPassword']),
    handleLogin() {
      const loginData = {
        email: this.email,
        password: this.password,
      };
      this.login(loginData);
    },
    handleResetPassword() {
      this.resetPassword(this.passwordForm.email);
      console.log('=== email: ' + this.email);
      console.log('=== passwordFormemail: ' + this.passwordForm.email);
      this.passwordResetSuccess = true;
      this.passwordForm.email = '';
    },
    toggleForm() {
      this.errorMsg = '';
      this.showLoginForm = !this.showLoginForm;
    },
  },
};
</script>
